import { Lock } from "lucide-react";
import { Section, Toggle } from "./fields";

// Directory + public community page privacy toggles.
export const PrivacySections = ({ form, set }) => (
  <>
    <Section icon={Lock} title="Privacidade & Diretório">
      <div className="text-sm text-[hsl(var(--muted-foreground))] mb-2 leading-relaxed">
        Por defeito, todos os sócios aprovados aparecem no Diretório com nome, foto, empresa, função, MBTI, valores VIA-ME, Ideal Pessoal, data e local da Aliança de Amor, <strong>email e telemóvel</strong>. Pode ocultar individualmente qualquer destes dados aqui. O texto da sua Aliança de Amor é sempre privado.
      </div>
      <Toggle
        label="Ocultar-me do Diretório de Sócios"
        hint="Quando ativo, o seu perfil completo deixa de aparecer no diretório."
        checked={form.hide_from_directory}
        onChange={(v) => set("hide_from_directory", v)}
        testid="hide-directory"
      />
      <Toggle
        label="Ocultar o meu email no diretório"
        checked={form.hide_email}
        onChange={(v) => set("hide_email", v)}
        disabled={form.hide_from_directory}
        testid="hide-email"
      />
      <Toggle
        label="Ocultar o meu telemóvel no diretório"
        checked={form.hide_phone}
        onChange={(v) => set("hide_phone", v)}
        disabled={form.hide_from_directory}
        testid="hide-phone"
      />
      <Toggle
        label="Ocultar o meu perfil MBTI no diretório"
        checked={form.hide_mbti}
        onChange={(v) => set("hide_mbti", v)}
        disabled={form.hide_from_directory}
        testid="hide-mbti"
      />
      <Toggle
        label="Ocultar os meus valores VIA-ME no diretório"
        checked={form.hide_via_values}
        onChange={(v) => set("hide_via_values", v)}
        disabled={form.hide_from_directory}
        testid="hide-via-values"
      />
      <Toggle
        label="Ocultar o meu Ideal Pessoal no diretório"
        checked={form.hide_ideal_pessoal}
        onChange={(v) => set("hide_ideal_pessoal", v)}
        disabled={form.hide_from_directory}
        testid="hide-ideal-pessoal"
      />
      <Toggle
        label="Ocultar a data e o local da minha Aliança de Amor no diretório"
        hint="O texto da sua Aliança de Amor é sempre privado e nunca é partilhado — este ajuste aplica-se apenas à data e ao local."
        checked={form.hide_alianca_amor}
        onChange={(v) => set("hide_alianca_amor", v)}
        disabled={form.hide_from_directory}
        testid="hide-alianca-amor"
      />
    </Section>

    <Section icon={Lock} title="Privacidade na página pública das Comunidades">
      <div className="text-sm text-[hsl(var(--muted-foreground))] mb-2 leading-relaxed">
        A página pública <strong>/comunidades/{`{slug}`}</strong> mostra a equipa de cada comunidade. Por padrão expõe apenas <strong>o seu nome e foto</strong> (o cargo profissional e a empresa nunca são publicados). Aqui pode escolher não aparecer de todo.
      </div>
      <Toggle
        label="Ocultar-me também da página pública das Comunidades"
        hint="Se ativo, o seu perfil deixa de aparecer na equipa visível ao público (continua visível para os outros sócios no Diretório, salvo se também ocultar lá)."
        checked={form.hide_from_community_page}
        onChange={(v) => set("hide_from_community_page", v)}
        testid="hide-from-community-page"
      />
    </Section>
  </>
);
